import DecisionScreen from './DecisionScreen';

export default DecisionScreen;
